import {
	permissionList,
	agentPermissionSet,
	attachmentPermissionSet,
	notesViewPermissionSet,
	hasPermissions,
} from "helpers";

export const getAgentTabs = () => [
	{
		path: "general-info",
		name: "General Info",
		requiredPermissions: agentPermissionSet,
	},
	{
		path: "schedule-a",
		name: "Schedule A`s",
		// requiredPermissions: Logic for permissions handling in EditAgentTabs Component,
	},
	{
		path: "residuals-split-profiles",
		name: "Residuals Split Profiles",
		// requiredPermissions: Logic for permissions handling in EditAgentTabs Component,
	},
	{
		path: "commission-split",
		name: "Commission Split",
	},
	{
		path: "attachments",
		name: "Attachments",
		requiredPermissions: attachmentPermissionSet,
	},
	{
		path: "branding",
		name: "Branding",
	},
	{
		path: "who-can-they-see",
		name: "Who can they see?",
		requiredPermissions: agentPermissionSet,
	},
	{
		path: "who-can-see-them",
		name: "Who can they see?",
		requiredPermissions: agentPermissionSet,
	},
	{
		path: "list-of-merchants",
		name: "List of Merchants",
		requiredPermissions: permissionList.SetUpMerchantLevelUser,
	},
	{
		path: "billing-information",
		name: "Billing Information",
	},
	{
		path: "notifications",
		name: "Notifications",
		requiredPermissions: agentPermissionSet,
	},
	{
		path: "notes",
		name: "Notes",
		requiredPermissions: notesViewPermissionSet,
	},
	{
		path: "history",
		name: "History",
	},
];

export const getAgentTabsPaths = () =>
	getAgentTabs()
		.filter(tab => hasPermissions(tab.requiredPermissions) && !tab.isHidden)
		.map(tab => tab.path);
